import { useLanguageSwitch } from '@/hooks/useLanguage';

export default function LanguageSwitcher() {
  const { switchLanguage, currentLang } = useLanguageSwitch();

  return (
    <div className="flex items-center gap-1">
      <button
        onClick={() => switchLanguage('en')}
        className={`text-[10px] tracking-wider px-2 py-1 rounded transition-colors cursor-pointer whitespace-nowrap ${
          currentLang === 'en'
            ? 'text-[#7B1113] font-semibold'
            : 'text-[#8A8A8A] hover:text-[#2A2A2A]'
        }`}
        aria-label="Switch to English"
      >
        EN
      </button>
      <span className="text-[#8A8A8A]/40 text-[10px]">|</span>
      <button
        onClick={() => switchLanguage('ko')}
        className={`text-[10px] tracking-wider px-2 py-1 rounded transition-colors cursor-pointer whitespace-nowrap ${
          currentLang === 'ko'
            ? 'text-[#7B1113] font-semibold'
            : 'text-[#8A8A8A] hover:text-[#2A2A2A]'
        }`}
        aria-label="Switch to Korean"
      >
        KR
      </button>
      <span className="text-[#8A8A8A]/40 text-[10px]">|</span>
      <button
        onClick={() => switchLanguage('bn')}
        className={`text-[10px] tracking-wider px-2 py-1 rounded transition-colors cursor-pointer whitespace-nowrap ${
          currentLang === 'bn'
            ? 'text-[#7B1113] font-semibold'
            : 'text-[#8A8A8A] hover:text-[#2A2A2A]'
        }`}
        aria-label="Switch to Bengali"
      >
        BN
      </button>
    </div>
  );
}